import { Routes } from "@angular/router";
import { TabConfig } from "../../_core/models";

const PROCUREMENT_TABS: TabConfig[] = [
    {
        path: 'vendors',
        title: 'Vendors',
        icon: 'store',
        loadTabComponent: () => import('./vendors/vendor-list/vendor-list.component').then((m) => m.VendorListComponent),
    },
    {
        path: 'rfqs',
        title: 'RFQs',
        icon: 'request_quote',
        loadTabComponent: () => import('./RFQS/rfq-list/rfq-list.component').then((m) => m.RfqListComponent),
    },
    {
        path: 'pos',
        title: 'Purchase Orders',
        icon: 'shopping_cart',
        loadTabComponent: () => import('./purchase-orders/purchase-orders-list/purchase-orders-list.component').then((m) => m.PurchaseOrdersListComponent),
    },
];

export const PROCUREMENT_ROUTES: Routes = [
    {
        path: 'procurement',
        title: 'Procurement',
        loadComponent: () => import('./procurement-tabs.component').then((e) => e.ProcurementTabsComponent),
        data: {
            icon: 'shopping_cart',
            module: 'PROCUREMENT',
            tabs: PROCUREMENT_TABS,
        },
        children: [
            ...PROCUREMENT_TABS.map((e) => {
                return {
                    path: e.path,
                    title: e.title,
                    data: {
                        reuse: true,
                        apiEndPoint: e.path,
                    },
                    loadComponent: e.loadTabComponent,
                };
            }),
            {
                path: '',
                redirectTo: 'vendors',
                pathMatch: 'full',
            },
        ]
    }
]
